import { combineReducers } from 'redux';

import coreProductInvoice from 'app/shared/reducers/analytics/coreProductInvoice';
import propertiesReport from 'app/shared/reducers/analytics/propertiesReport';
import boostAdReport from 'app/shared/reducers/analytics/boostAdReport';
import graphs from 'app/shared/reducers/analytics/graphs';
import overviewFilter from 'app/shared/reducers/analytics/overviewFilter';

const rootAnalyticsReducer = combineReducers({
    coreProductInvoice,
    propertiesReport,
    boostAdReport,
    graphs,
    overviewFilter,
});

export default rootAnalyticsReducer;
